import { Navigate, useParams } from "react-router-dom";
import {
  audienceFromRouteParam,
  helpCenterCategoryPathWithSubSection,
} from "./helpCenterRoutes";

export default function HelpCenterLegacySubSectionRedirect() {
  const { audience: audienceParam, sectionId, subSectionId } = useParams();
  const audience = audienceFromRouteParam(audienceParam);

  if (!audience || !sectionId || !subSectionId) {
    return <Navigate to="/help-center" replace />;
  }

  const target = helpCenterCategoryPathWithSubSection(
    audience,
    sectionId,
    subSectionId,
  );

  return <Navigate to={target.pathname} state={target.state} replace />;
}
